import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ReactQueryDevtools } from 'react-query/devtools';
import {
  ErrorBoundary,
  LeagueProvider,
  QueryClientProvider,
} from '@highmark-web/highmark-common';
import { AppRoutes } from 'common/routes';
import { initializeNonConfigSDKs, config } from './init-config';

initializeNonConfigSDKs();

export function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider>
        <LeagueProvider config={config}>
          <ErrorBoundary contextLocation="Root App ErrorBoundary">
            <AppRoutes />
            <ReactQueryDevtools />
          </ErrorBoundary>
        </LeagueProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
